import { z } from "zod";

const pulseFilterSchema = z.enum(["all", "active", "paused"]);
const channelFilterSchema = z.enum(["all", "slack", "email", "ms_teams"]);

/** URL search-params schema for `/$workspaceSlug/my-team`. */
export const myTeamSearchSchema = z
  .object({
    includeIndirect: z.boolean().optional(),
    /** Selected membership IDs, comma-joined. */
    selected: z.string().optional(),
    /** Free-text search (name / email / title). Client-side filter. */
    q: z.string().optional(),
    pulse: pulseFilterSchema.catch("all").default("all"),
    channel: channelFilterSchema.catch("all").default("all"),
  })
  .strict();

export type MyTeamSearch = z.infer<typeof myTeamSearchSchema>;
